import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import {
  AssignmentDateListItemResponse,
  BaseAssignmentDateStatusEnum,
  baseAssignmentsActions,
  BaseButtonSize,
  BaseCoreState,
  BaseDateService,
  BaseInquiryShifts,
  BaseModalHeaderSizes,
  BaseModalService,
  ShiftTimeResponse,
} from 'base';

@Component({
  selector: 'base-customer-employee-time-recordings-list-item',
  templateUrl: './base-customer-employee-time-recordings-list-item.component.html',
})
export class BaseCustomerEmployeeTimeRecordingsListItemComponent implements OnInit {
  @Input() assignmentDate: AssignmentDateListItemResponse;
  @Input() assignmentId: number;
  @ViewChild('confirmPopup') confirmPopup: ElementRef;
  tooltipAssignmentDate: AssignmentDateListItemResponse;
  targetShiftTime: ShiftTimeResponse | undefined;
  canBeReleased: boolean;
  modalRef: NgbModalRef;
  buttonSize = BaseButtonSize;
  shiftTypes = BaseInquiryShifts;
  assignmentDateStatus = BaseAssignmentDateStatusEnum;

  constructor(private modalService: BaseModalService, private store: Store<BaseCoreState>) {}

  ngOnInit(): void {
    this.canBeReleased = this.isReleaseAllowed();
    this.targetShiftTime = this.assignmentDate.shiftTimes.find((shiftTime) =>
      !!this.assignmentDate.shift
        ? shiftTime.type === this.assignmentDate.shift
        : shiftTime.type === this.assignmentDate.workShift
    ) as ShiftTimeResponse;
  }

  getTimeRange(data: AssignmentDateListItemResponse, isStartTime: boolean): string {
    return isStartTime ? data.workStartTime || '' : data.workEndTime || '';
  }

  handleShowConfirmPopup(assignmentDateId: number): void {
    this.modalRef = this.modalService.open({
      headText: 'operations.confirm.time',
      headerSize: BaseModalHeaderSizes.md,
      bodyTemplate: this.confirmPopup,
      okText: 'action.confirm',
    });
    this.modalRef.result.then(() => {
      this.store.dispatch(
        baseAssignmentsActions.confirmAssignment({
          payload: { assignment: this.assignmentId, assignmentDate: assignmentDateId },
        })
      );
    }, noop);
  }

  private isReleaseAllowed(): boolean {
    const today = new Date();
    const isReleaseByDateAllowed =
      BaseDateService.isAfter(today, new Date(this.assignmentDate.date)) ||
      BaseDateService.isToday(new Date(this.assignmentDate.date));
    const isReleaseByStatusAllowed = this.assignmentDate.status === this.assignmentDateStatus.SUBMITTED;
    const isReleaseByTimeRecordsAllowed = !!this.assignmentDate.timeWork;

    return isReleaseByDateAllowed && isReleaseByStatusAllowed && isReleaseByTimeRecordsAllowed;
  }
}
